<template>
  <div class="layout">
    <header
      :class="{
        'layout__header': true,
        'p-AJ': (slots.header || props$$.title)
      }"
    >
      <slot
        v-if="slots.header"
        name="header"
      ></slot>
      <!-- <TitlePage
        v-else
        :title="props$$.title"
      /> -->
    </header>
    <div class="layout__body p-AJ">
      <slot name="body"></slot>
    </div>
    <Footer />
  </div>
</template>

<script setup>

// #region VUE
import {
  useSlots,
} from 'vue';
// #endregion

// #region COMPONENTS COMPOSABLES
// import TitlePage from '@/components/title-page/TitlePage.vue';
import Footer from '@/components/footer/Footer.vue';
// #endregion

// #region Props, Emits
const props$$ = defineProps({
  title: {
    type: String,
    default: '',
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const slots = useSlots();
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.layout {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  width: 100%;
  &__body{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
        -ms-flex: 1;
            flex: 1;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;

    flex-direction: column;

    min-height: 45vh;
    background:
      url(https://cdn.transportes.gob.es/portal-web-drupal/Iconos-verano-joven/fondo_viajar.jpg)
      repeat-x bottom center;
    background-size: 460px;
    align-items: center;

    @media print {
      min-height: auto;
    }

    .title-page {
      border-left: none;
      padding-left: 0;
      position: relative;
    }
  }
}

</style>
